import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100",
  style: {"margin-top":"20px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"65%","min-width":"155px"} }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"35%","min-width":"155px"} }, null, -1)
const _hoisted_4 = { style: {"padding":"0 0 0 20px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "fl fw400 fs9 grey"
}
const _hoisted_8 = ["src", "onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"5px","margin-left":"-3px"} }, " 編集", -1)
const _hoisted_12 = {
  key: 1,
  class: "grey",
  style: {"margin-top":"10px"}
}
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.Util.isPresent(_ctx.members))
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (member, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: `${index}${member.user_id}${member.systemUpdatedAt}`,
            style: {"height":"60px","border":"1px solid #ededed","box-shadow":"1px 1px 1px rgba(0, 0, 0, 0.2)"},
            class: "with_shadow"
          }, [
            _createElementVNode("td", _hoisted_4, [
              (member.company_name)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(`${_ctx.isSP ? `fs12` : `fs9`} fw600`)
                  }, [
                    _createTextVNode(_toDisplayString(member.company_name) + " ", 1),
                    _hoisted_5
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: _normalizeClass(`fl fw600 ${_ctx.isSP ? `fs16` : ``}`),
                style: _normalizeStyle(`${member.company_name ? `` : `margin-top:0;`}`)
              }, _toDisplayString(member.name), 7),
              _hoisted_6,
              (member.email)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.truncate(member.email, 30)), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
                width: "30",
                height: "30",
                class: "fr pointer",
                style: {"margin-right":"5%"},
                onClick: ($event: any) => (_ctx.deleteMember(member))
              }, null, 8, _hoisted_8),
              _createElementVNode("label", {
                class: _normalizeClass(`circle_button fw400 fr centered lblueBg fs12 blueAround`),
                style: {"width":"80px","padding":"4px 10px","margin-right":"10px","margin-top":"3px"},
                onClick: ($event: any) => (_ctx.editAttendee(member))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/editPen.png`),
                  width: "14",
                  height: "14",
                  style: {"margin-top":"-3px"}
                }, null, 8, _hoisted_10),
                _hoisted_11
              ], 8, _hoisted_9)
            ])
          ]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
        _createTextVNode(" 出席者がいません。下から出席者を追加してください。 "),
        _createElementVNode("img", {
          src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
          width: "24",
          height: "24",
          style: {"margin-top":"-8px"}
        }, null, 8, _hoisted_13)
      ]))
}